import React from "react";
import { fetchOldLoanPortfolio } from "../../store/reducers/dashboardSlice/api";
import {
  gridColumns_PastPortfolio,
  gridColumns_PastPortfolioBroker,
} from "../../Utils/TableColumnDefs";
import CommonGrid from "../CommonGrid";
import useFetchTableData from "../../useFetchTableData";
import { useSelector } from "react-redux";
import { roleType } from "../../Utils/constant";

const pastLoanFilter = [
  { name: "Principal Amount", key: "principal", type: "range" },
  { name: "Payoff Date", key: "payoff_date", type: "date" },
  { name: "Payoff Date", key: "payoff_date", type: "month" },
];

const PastLoanPortfolioTable = ({ className = "" }) => {
  const selectedRole = useSelector((state) => state.account.selectedRole.value);
  const { data, status, retry } = useFetchTableData(
    fetchOldLoanPortfolio,
    "oldLoanPortfolio"
  );

  return (
    <CommonGrid
      className={`past-loan-portfolio col-sm-6 ${className}`}
      title={"Past Loan Portfolio"}
      gridColumns={
        selectedRole === roleType.broker
          ? gridColumns_PastPortfolioBroker
          : gridColumns_PastPortfolio
      }
      columnData={data}
      filterOption={pastLoanFilter}
      tableTotal={["principal"]}
      status={status}
      onRetry={retry}
    />
  );
};

export default PastLoanPortfolioTable;
